export const HISTORICAL_PHASE5_ERROR =
  'Generation failed. Detailed error was not recorded for this older job.';

const LEGACY_GENERIC_ERRORS = new Set([
  'Generation failed',
  'Generation failed.',
  'Generation failed. Please try again.',
  'Something went wrong. Please try again.',
]);

export function phase5JobErrorMessage(job = {}) {
  const message = typeof job.error_message === 'string' && job.error_message.trim()
    ? job.error_message.trim()
    : typeof job.error === 'string' && job.error.trim()
      ? job.error.trim()
      : '';
  if (!message || LEGACY_GENERIC_ERRORS.has(message)) return HISTORICAL_PHASE5_ERROR;
  const code = typeof job.error_code === 'string' && /^[A-Z0-9_]{2,80}$/.test(job.error_code)
    ? job.error_code
    : '';
  if (job.status === 'failed' && job.job_type === 'next_steps') {
    const firstSection = Array.isArray(job.missing_sections)
      ? job.missing_sections.find((section) => typeof section === 'string' && section.trim())
      : '';
    if (job.http_status === 429 || code === 'NEXT_STEPS_PROVIDER_RATE_LIMITED') {
      return 'Next Steps provider rate limit was reached. Your previous saved Analysis has not been changed.';
    }
    if (code === 'NEXT_JSON_DECODE_FAILURE') {
      return 'Next Steps structured response could not be decoded. Your previous saved Analysis has not been changed.';
    }
    if (code === 'NEXT_PROVIDER_TRUNCATION') {
      return 'Next Steps provider output was truncated. Your previous saved Analysis has not been changed.';
    }
    if (code === 'NEXT_MISSING_SECTION' || code === 'NEXT_EMPTY_SECTION' || code === 'NEXT_SECTION_TITLE_MISMATCH') {
      return `Next Steps response was incomplete${firstSection ? `: ${code === 'NEXT_EMPTY_SECTION' ? 'empty' : 'missing'} section ${firstSection}` : ''}. Your previous saved Analysis has not been changed.`;
    }
    if (code === 'NEXT_SCHEMA_MISMATCH') {
      return 'Next Steps structured response was ambiguous or invalid. Your previous saved Analysis has not been changed.';
    }
    return 'Analysis generation did not complete. Your previous saved Analysis has not been changed.';
  }
  if (code === 'DEEPSEEK_REASONING_WITHOUT_FINAL_CONTENT') {
    return 'Analysis generation did not complete because the model did not return final Analysis content. Your previous saved Analysis has not been changed.';
  }
  if (['WHY_REASONING_UNSUPPORTED', 'NEXT_REASONING_UNSUPPORTED', 'NEXUS_REASONING_UNSUPPORTED'].includes(code)) {
    return 'The currently selected AI model does not support the required reasoning mode for this Analysis. Select a reasoning-capable model in Admin Settings.';
  }
  if (code === 'WHY_OUTPUT_TRUNCATED') {
    return 'Analysis generation failed because the provider returned incomplete output. Your previous Analysis has been preserved.';
  }
  if (code === 'WHY_INCOMPLETE_STRUCTURE' || code === 'WHY_SECTION_VALIDATION_FAILED') {
    return 'Analysis generation failed during final validation. Your previous Analysis has been preserved.';
  }
  if (code === 'NEXT_STEPS_INCOMPLETE_STRUCTURE') {
    return 'Analysis generation did not complete. Your previous saved Analysis has not been changed.';
  }
  return code && !message.startsWith(`${code}:`) ? `${code}: ${message}` : message;
}

export function phase5JobFailure(job = {}) {
  const error = new Error(phase5JobErrorMessage(job));
  error.jobFailed = true;
  error.errorCode = job.error_code || null;
  return error;
}

export const PHASE5_REPORT_LABELS = {
  why: 'Patterns & Contributing Themes',
  next: 'Next Steps',
  nexus: 'Nexus',
};

export const phase5FailureTitle = (kind) =>
  `${PHASE5_REPORT_LABELS[kind] || 'Analysis'} Generation Failed`;
